import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Box } from '@mui/material';
import { ContentBlock } from '../../types';

import HeadingBlock from './types/HeadingBlock';
import ParagraphBlock from './types/ParagraphBlock';
import ListBlock from './types/ListBlock';
import QuoteBlock from './types/QuoteBlock';
import ButtonBlock from './types/ButtonBlock';

interface AnimatedSectionsProps {
    section: ContentBlock;
    index: number;
    pageKey: string;
}

export default function Sections({section, index, pageKey}: AnimatedSectionsProps) {
    const ref = useRef(null);
    const inView = useInView(ref, {
        margin: '-100px',
        once: true
    });

    return (
        <motion.div
            key={`${pageKey || 'page'}-${index}`}
            ref={ref}
            initial={{ opacity: 0, y: 80 }}
            animate={
                inView
                ? { opacity: 1, y: 0 }
                : { opacity: 0, y: 80 }
            }
            transition={{
                duration: 0.8,
                ease: [0.25, 0.1, 0.25, 1], 
            }}
        >
            <Box sx={{ padding: '100px 0px 80px' }}>
                {section.blocks.map((block, j) => {
                    switch (block.type) {
                        case 'heading':
                            return <HeadingBlock key={j} block={block} />;
                        case 'paragraph':
                            return <ParagraphBlock key={j} block={block} />;
                        case 'list':
                            return <ListBlock key={j} block={block} />;
                        case 'quote':
                            return <QuoteBlock key={j} block={block} />;
                        case 'button':
                            return <ButtonBlock key={j} block={block} />;
                        default:
                            return null;
                    }
                })}
            </Box>
        </motion.div>
    );
}